import { render, staticRenderFns } from "./LabelBase.vue?vue&type=template&id=ee6e8a16&scoped=true&lang=pug&"
import script from "./LabelBase.vue?vue&type=script&lang=ts&"
export * from "./LabelBase.vue?vue&type=script&lang=ts&"
import style0 from "./LabelBase.vue?vue&type=style&index=0&id=ee6e8a16&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6e8a16",
  null
  
)

export default component.exports